module.exports = __webpack_public_path__ + "img/spin_btn.023cc38c.png";